(function () {
    var userProfileInfo = {};

    angular.module('directives')
        .directive('hTsHeaderUserIcon', ['hUser', 'brandServices', function(hUser, brandServices) {
            return {
                restrict: 'E',
                link: function(scope) {
                    scope.user = hUser.data.user;
                    scope.isLMSElearningServiceEnabled = false;
                    scope.canAccessLiveSchedule = false;

                    var getAcademyRedirectionLink = function() {
                        UserAPI.getAcademyLink()
                            .then(function(res) {
                                scope.academyRedirectionLink = res['redirection_link'];
                            })
                            .catch(function (err) {
                                console.error(err && err.data);
                            })
                            .finally(function () {
                            scope.$digest();
                        });
                    };

                    if(hUser.isLoggedIn()) {
                        if(!userProfileInfo[scope.user.id]) {
                            MemberAPI.getProfile(scope.user.id).then(function (result) {
                                userProfileInfo[scope.user.id] = result;
                                scope.profileInfo = userProfileInfo[scope.user.id];

                                setTimeout(function() {
                                    scope.$digest();
                                }, 1);
                            });
                        } else {
                            scope.profileInfo = userProfileInfo[scope.user.id];
                        }
                        brandServices.check(brandServices.SERVICES.LMS, hUser.getEntryMode().brand_id)
                            .then(function (res) {
                                if(res) {
                                    getAcademyRedirectionLink();
                                }
                            });
                        brandServices.check(brandServices.SERVICES.HARRI_ACADEMY, hUser.getEntryMode().brand_id)
                            .then(function (res) {
                                if (res) {
                                    scope.isLMSElearningServiceEnabled = res;
                                }
                            });
                        LiveScheduleAPI.checkIfBrandHasAvailableShiftsEmailsService(hUser.getEntryMode().brand_id)
                            .then(function (availableShiftsEnabled) {
                                scope.canAccessLiveSchedule = availableShiftsEnabled;
                            });
                    }

                    scope.isHMAPUser = function () {
                        return hUser.isEmployer() ? hUser.isHMAPUser() : false;
                    };

                },
                templateUrl: '../hmodules/directives/h-ts-header-user-icon/h-ts-header-user-icon.directive.html',
            };
        }]);
})();